// Een pad dat met // of /\ begint leest een browser als een externe host, ook
// al ziet het er relatief uit. Alleen een enkele slash met daarna geen slash
// of backslash is veilig.
const SAFE_PATH = /^\/(?![/\\])[^\s]*$/;

export function safeRedirectTarget(value: string | null): string | null {
  if (!value || !SAFE_PATH.test(value)) {
    return null;
  }
  return value.startsWith('/login') ? null : value;
}

// Een deeplink uit de signaalmail draagt de bestemming als ?redirectTo= op
// /login. Wie daar naar "wachtwoord vergeten" klikt en terugkomt, verloor hem:
// die links wezen kaal naar /login en /login/forgot. Na het inloggen landde de
// klant dan op het dashboard in plaats van op het stuk uit de mail.
export function withRedirectTarget(path: string, search: string): string {
  const target = safeRedirectTarget(new URLSearchParams(search).get('redirectTo'));
  return target ? `${path}?redirectTo=${encodeURIComponent(target)}` : path;
}
